import { render } from "./JobTemplate.vue?vue&type=template&id=2a008446&scoped=true"
import script from "./JobTemplate.vue?vue&type=script&lang=js"
export * from "./JobTemplate.vue?vue&type=script&lang=js"

import "./JobTemplate.vue?vue&type=style&index=0&id=2a008446&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a008446"]])

export default __exports__